import React from 'react';

import PatientViewComposer from '../../../composers/PatientViewComposer';

export default function PatientViewPage(): JSX.Element {
  return <PatientViewComposer />;
}
